"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _uiActions = require("../../store/ui/uiActions");
var _upsellActions = require("../../store/upsell/upsellActions");
var _constants = require("../../utils/constants");
var _useAppDispatch = require("../useAppDispatch");
const useInsuranceActions = () => {
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const onViewMore = product => {
    dispatch((0, _upsellActions.addDisplayedUpsellProductDetails)(product));
    dispatch((0, _uiActions.setDynamicPageContent)(_constants.DYNAMIC_PAGES.INSURANCE_DETAILS));
    dispatch((0, _uiActions.goToDynamicPage)());
  };
  return {
    onViewMore
  };
};
var _default = useInsuranceActions;
exports.default = _default;